import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";

import mobile from "../../api/users";
import { handleError } from "@/util/errorHandler";

class MobileUserSearch extends Component {
  state = {
    phone: "",
    userInfo: [],
  };

  headerStyle = {
    backgroundColor: "#D15050",
    color: "white",
  };

  handleInputChange = event => {
    this.setState({
      phone: event.target.value,
    });
  };

  handleSearchClick = async event => {
    event.preventDefault();
    if (this.state.phone.length > 0) {
      mobile
        .getUserInfoByPhoneNumber(this.state.phone)
        .then(userInfo => {
          this.setState({ userInfo: [userInfo] });
        })
        .catch(error => {
          handleError(error);
        });
    }
  };

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>Search mobile user</CardHeader>
              <CardBody>
                <Form onSubmit={this.handleSearchClick}>
                  <FormGroup>
                    <Label>Please input customer primary contact:</Label>
                    <Input
                      type="text"
                      name="phone"
                      id="phone"
                      placeholder="Primary contact"
                      value={this.state.phone}
                      onChange={this.handleInputChange}></Input>
                  </FormGroup>
                  <FormGroup>
                    <Button
                      color="primary"
                      type="button"
                      onClick={this.handleSearchClick}>
                      Search
                    </Button>
                  </FormGroup>
                </Form>
                <BootstrapTable
                  data={this.state.userInfo}
                  headerStyle={this.headerStyle}
                  version="4"
                  striped
                  hover
                  condensed
                  remote>
                  <TableHeaderColumn dataField="name" width="200" isKey>
                    Full Name
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="accountId" width="100">
                    Account ID
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="primaryContact" width="140">
                    Primary Contact
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="bankName" width="140">
                    Registered Bank
                  </TableHeaderColumn>
                </BootstrapTable>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default MobileUserSearch;
